/**
 * 域名测试初始化
 * 此文件会被index.js最早加载，确保域名模拟生效
 */

console.log('======= 域名测试初始化模块开始 =======');

// 定义全局变量
window.MOCK_HOSTNAME = null;

// 解析URL参数
function parseUrlForDomain() {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const domainParam = urlParams.get('domain');

    console.log('domainTestSetup.js - URL参数domain:', domainParam);

    if (domainParam === 'huiya') {
      window.MOCK_HOSTNAME = 'huiyabook.cn';
      console.log('domainTestSetup.js - 设置模拟域名为:', window.MOCK_HOSTNAME);
    } else if (domainParam === 'deerbook') {
      window.MOCK_HOSTNAME = 'deerbook.cn';
      console.log('domainTestSetup.js - 设置模拟域名为:', window.MOCK_HOSTNAME);
    } else {
      console.log('domainTestSetup.js - 使用真实域名:', window.location.hostname);
    }
  } catch (e) {
    console.error('domainTestSetup.js - 解析URL参数出错:', e);
  }
}

// 立即执行
parseUrlForDomain();

// 替换getHostname函数
window.getHostname = function() {
  return window.MOCK_HOSTNAME || window.location.hostname;
};

console.log('======= 域名测试初始化模块完成 ======='); 